module.exports = __webpack_public_path__ + "img/svg/background-user-rankings-mobile.b1c9bceea9b7d5c73392e7e93e085cfa.svg";